// Shared constants for point label positioning in line charts

export const DEFAULT_FONT_SIZE = 12; // Default font size for point labels
export const EDGE_PADDING = 5; // Minimum padding from chart edges
export const LABEL_POINT_GAP = 10; // Gap between label and point edge
// NOTE: LineChart.js sets pointSize={8} which is the diameter of the circle.
// We need the radius to calculate spacing from the point's edge, not its center.
export const POINT_RADIUS = 4;
